import { ListItem, TableCell } from '@mui/material';
import { getDeliveryInfo } from '@components/Pages/Events/Sessions/sessionFunctions';
import CellList from './CellList';

const DeliveryLocationCell = ({ session }) => {
  const info = getDeliveryInfo(session);

  return <TableCell align="left">
    {info.length > 1 && (
      <CellList>
        {info.map((detail, i) => (
          <ListItem key={`method-details-${i}`} disableGutters>
            <span>{detail}</span>
          </ListItem>
        ))}
      </CellList>
    )}
    {info.length === 1 && info[0]}
  </TableCell>;
};

export default DeliveryLocationCell;
